const recommendationTemplate = require('plugin_catalog/product/recommendation');
const CONST = require('plugin_frontend_core/constants');

const classes = {
    productAdded: 'product-added'
};

const selectors = {
    addToCartButtons: '.js-add-to-cart',
    productTile: '.js-productTile',
    crossSellProductTile: '.js-product-cross-sell-item',
    wrapper: '#productCrossSell'
};

const modalSelectors = {
    modalProductBrand: '.js-product-brand',
    modalProductName: '.js-product-name',
    modalProductSize: '.js-product-size',
    modalProductImage: '.js-product-image',
    modalProductPrice: '.js-product-price',
    modalRecommendations: '.js-product-cross-sell-container'
};

/**
 * @private onAfterAddToCart
 * @param {Event} evt - A custom click event
 */
function onAfterAddToCart(evt) {
    // remove the existing listener as products are supposed to only be added once.
    evt.target.removeEventListener(CONST.events.click, onAfterAddToCart);
    const productID = evt.target.getAttribute('data-pid');
    $('body').on(CONST.events.productAfterAddToCart, (e, response) => {
        if (response.productID && response.productID === productID) {
            evt.target.closest(selectors.productTile).classList.add(classes.productAdded);
        }
    });
}

/**
 * @private setModalData
 * @param {modal} $modal - Modal dom element to fill
 * @param {responseData} responseData - Raw add to cart data for the modal content
 */
function setModalData(modal, responseData) {
    const productID = responseData.productID;
    const addedItem = responseData.cart.items.find(obj => obj.id === productID);
    const hasRecommendations = responseData.recommendations && responseData.recommendations.length > 0;

    if (!productID || !addedItem || !hasRecommendations) return false;

    modal.querySelector(modalSelectors.modalProductBrand).innerHTML = addedItem.brand;
    modal.querySelector(modalSelectors.modalProductName).innerHTML = addedItem.productName;
    modal.querySelector(modalSelectors.modalProductPrice).innerHTML = '';
    if (addedItem.price.list) {
        let discountPrice = document.createElement("span");
        discountPrice.className = "strike-through list";
        discountPrice.innerHTML = addedItem.price.list.formatted;
        modal.querySelector(modalSelectors.modalProductPrice).appendChild(discountPrice);
    }

    if (addedItem.price.sales) {
        let orderPrice = document.createElement("span");
        orderPrice.className = "sales";
        orderPrice.innerHTML = addedItem.price.sales.formatted;
        modal.querySelector(modalSelectors.modalProductPrice).appendChild(orderPrice);
    }

    if (productSize = addedItem.variationAttributes.find(obj => obj.attributeId === "size")) {
        modal.querySelector(modalSelectors.modalProductSize).innerHTML = `${productSize.displayName} : ${productSize.displayValue}`;
    }

    if (productImage = addedItem.images.medium[0]) {
        let modalImage = document.createElement("img");
        modalImage.src = productImage.url;
        modalImage.alt = productImage.alt
        modal.querySelector(modalSelectors.modalProductImage).appendChild(modalImage);
    }

    // Add recommendations to the modal when not opened
    if (!modal.classList.contains('show')) {
        let template = '';
        let modalRecommendations = modal.querySelector(modalSelectors.modalRecommendations);
        modalRecommendations.innerHTML = '';
        responseData.recommendations.forEach(recom => {
            template += recommendationTemplate(recom, responseData.addToCartURL, responseData.addedResource);
        });
        modalRecommendations.innerHTML = template;

        // add event listener to each add to cart button
        const addToCartButtons = modalRecommendations.querySelectorAll(selectors.addToCartButtons);
        Array.from(addToCartButtons).forEach(button => {
            button.addEventListener(CONST.events.click, onAfterAddToCart);
        });
    }

    return true;
}

/**
 * @public crosseSell
 */
function crossSell(evt, responseData) {
    const crossSellModal = document.querySelector(selectors.wrapper);

    if (!crossSellModal) {
        return;
    }

    if (setModalData(crossSellModal, responseData)) {
        $(crossSellModal).modal({ focus: false });

        const crossSellRecommendedProductTiles = $(crossSellModal).find(selectors.crossSellProductTile);
        $(document).trigger(CONST.events.productTileImpression, [crossSellRecommendedProductTiles.toArray()]);
    }
}

module.exports = $('body').on(CONST.events.productAfterAddToCart, crossSell);
